import { render, staticRenderFns } from "./EditBuilding.vue?vue&type=template&id=04f4dcd9&"
import script from "./EditBuilding.vue?vue&type=script&lang=ts&"
export * from "./EditBuilding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports